<template>
    <div class="master-section appointment-layout section_1">
        <section class="row align-items-center px-0 px-md-1 mb-40px mb-md-60px mx-0 mx-md-1">
            <div class="col-12 col-md-6 mx-auto">
                <div class="master-template__form">
                    <h2 class="master-template__form-title" v-if="title_form"> {{ title_form }}</h2>
                    <div class="master-template__form-descirption" v-if="description" v-html ="description"></div>
                    <form @submit.prevent="submitForm" class="altform master-template__form-fields" id="master-tempalte-form" @click="startLoadRecaptcha">
                        <FormSelect
                            v-model="form.store"
                            @clearError="clearFieldError('store')"
                            :options="option_store"
                            required
                            label="Select Store"
                            placeholder="Select Store"
                            :rules="[{ required: 'Please select a store' }]"
                            :errorMessage="errors.store"
                        />

                        <div class="row">
                            <div class="col-md-6">
                                <FormInput
                                    v-model="form.date"
                                    @clearError="clearFieldError('date')"
                                    label="Preferred Date"
                                    required
                                    :offsetDays=2
                                    placeholder="Date"
                                    type="date"
                                    :minDate="true"
                                    :disabled-dates="blockedDates"
                                    :rules="[
                                        { type: 'required', message: 'Please select a date' },
                                        { type: 'workdayOnly' },
                                        { type: 'futureOnly' }
                                    ]"
                                    :errorMessage="errors.date"
                                    />
                            </div>
                            <div class="col-md-6 custom_time">
                                <FormSelect
                                    v-model="form.time"
                                    @clearError="clearFieldError('time')"
                                    :options="timeOptions"
                                    label="Preferred Time"
                                    :errorMessage="errors.time"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="master-template__form--field-set">Personal Information</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <FormInput
                                    v-model="form.first_name"
                                    required
                                    @clearError="clearFieldError('first_name')"
                                    label="First Name"
                                    placeholder=""
                                    :rules="[
                                        { required: 'Please enter your First name' },
                                        { pattern: { value: /^[A-Za-z ]+$/, message: 'First Name cannot contain numbers' } },
                                        { maxLength: { value: 50, message: 'First Name cannot exceed 50 characters' } }
                                    ]"
                                    :errorMessage="errors.first_name"
                                />
                            </div>
                            <div class="col-md-6">
                                <FormInput
                                    v-model="form.last_name"
                                    required
                                    @clearError="clearFieldError('last_name')"
                                    label="Last Name"
                                    placeholder=""
                                    :rules="[
                                        { required: 'Please enter your Last name' },
                                        { pattern: { value: /^[A-Za-z ]+$/, message: 'Last Name cannot contain numbers' } },
                                        { maxLength: { value: 50, message: 'Last Name cannot exceed 50 characters' } }
                                    ]"
                                    :errorMessage="errors.last_name"
                                />
                            </div>
                        </div>
                        <div id="email-form-group" class=" alt-form-group email-form-group form-group">
                            <FormInput
                                v-model="form.email"
                                @clearError="clearFieldError('email')"
                                required
                                label="Email Address"
                                placeholder=""
                                type="text"
                                :rules="[
                                    { required: 'Please enter your Email' },
                                    { maxLength: 50, message: 'Email cannot be longer than 50 characters' },
                                    { isEmail: true, message: 'Please enter a valid email address' }
                                ]"
                                :errorMessage="errors.email"
                            />
                        </div>
                        <div id="phone-form-group" class="alt-form-group text-form-group form-group">
                            <FormInput
                                v-model="form.phone"
                                required
                                @clearError="clearFieldError('phone')"
                                label="Contact Number (Malaysia Only)"
                                placeholder=""
                                :rules="[
                                    { required: 'Please enter your Contact number' },
                                    { pattern: { value: /^[0-9]+$/, message: 'Contact Number cannot contain alphabets' } },
                                    { minLength: 8, message: 'Length is 8-15 characters.' },
                                    { maxLength: 15, message: 'Length is 8-15 characters.' }
                                ]"
                                :errorMessage="errors.phone"
                            />
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <FormInput
                                    v-model="form.message"
                                    @clearError="clearFieldError('message')"
                                    label="message"
                                    placeholder="Include any special request, or query that you may have regarding your ear piercings!"
                                    type="textarea"
                                    :errorMessage="errors.message"
                                    />
                            </div>
                        </div>
                        <div id="alt-recaptcha">
                            <Recaptcha ref="recaptchaRef" v-if="siteKey_recapcha"  v-model="form.recaptcha" :siteKey="siteKey_recapcha" />
                        </div>
                        <div id="item_marketing_consent-form-group" class="alt-form-group checkbox-form-group form-group">
                            <FormCheckbox
                                v-model="form.item_marketing_consent"
                                @clearError="clearFieldError('item_marketing_consent')"
                                label="I agree to receive marketing communications from SK Jewellery"
                                id="item_marketing_consent"
                                :rules="[{ required: 'This field is required' }]"
                                :errorMessage="errors.item_marketing_consent"
                            />
                        </div>
                        <!-- Submit Button -->
                        <div class="altform-submit-group">
                            <button :disabled="isSubmitting" type="submit" class="btn button-submit">
                                <span class="button__text">
                                    Request a Consultation Slot
                                </span>
                            </button>
                            <div v-if="isSubmitting" class="loading"> </div>
                        </div>
                        <p v-if="responseMessage" class="altform-message" :class="{'success-message': isSuccess, 'text-danger': !isSuccess }">
                        {{ responseMessage }}
                        </p>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>
<script lang="ts" setup>
    import FormSelect from "~/components/Career/Forms/FormSelect.vue";
    import FormInput from "~/components/Career/Forms/FormInput.vue";
    import FormCheckbox from "~/components/Career/Forms/FormCheckbox.vue";
    import Recaptcha from '~/components/Career/Forms/Recaptcha.vue';
    const { $ajax } = useNuxtApp();

    const props = defineProps({
        data_title: String,
        data_description: String,
        data_key: String,
        data_postId: Number,
        data_store: Array,
    });
    const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
    const isSubmitting = ref(false);
    const responseMessage = ref('');
    const isSuccess = ref(false);
    const recaptchaRef = ref(null);
    const siteKey = ref(props.data_key);

    const userStore = useUserStore();

    const title_form = computed(() => props.data_title);
    const description = computed(() => props.data_description);
    const siteKey_recapcha = computed(() => props.data_key);
    const post_id_form = computed(() => props.data_postId);
    const option_store = computed(() => props.data_store);
    const clearDatePicker = () => {
        nextTick(() => {
            // Type assertion to HTMLElement to access `click` method
            const clearBtn = document.querySelector('.dp--clear-btn') as HTMLElement;
            if (clearBtn) {
                clearBtn.click();
            } else {
                console.warn("Clear button not found.");
            }
        });
    };
    const failedCaptcha = ref(0);
    const submitForm = async () => {
        responseMessage.value = '';
        if (isSubmitting.value) return;
        const isValid = validateForm();
        if (!isValid) {
            responseMessage.value = 'Please enter all required fields'
            return;
        }
        if (recaptchaRef.value){
            recaptchaRef.value.getToken();
        }

        if (!form.value.recaptcha) {
            return;
        }
       
        try {
            isSubmitting.value = true;
            // Create FormData object
            const formData = new FormData();

            // Append all form fields to FormData object
            for (const key in form.value) {
                const value = form.value[key as keyof FormState];
                formData.append(key, String(value));

            }

            formData.append('failed_cappcha',String(failedCaptcha.value));

            // const response = await $ajax.post<IRegisterResponse>('wp-json/skj/v1/register', registerData.value, {
            //     headers: {"Authorization": `Bearer ${userStore.csrf}`,"Accept": 'application/json'}
            // });

            const response = await $ajax.post('wp-json/skj/v1/submit_kform', formData, {
                headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${userStore.csrf}`
                }
            });
            
            if(response.result.success) {
                failedCaptcha.value = 0;
                pushToDataLayer('book_appointment');
                isSuccess.value = true;
                responseMessage.value = response.message || 'Thank for contacting us! We will get in touch with you shortly';
                form.value.store = '';
                form.value.date = '';
                form.value.time = '';
                form.value.first_name = '';
                form.value.last_name = '';
                form.value.phone = '';
                form.value.email = '';
                form.value.message = '';
                form.value.item_marketing_consent = false;
                clearDatePicker();
            }
        } catch (error) {
            isSuccess.value = false;
            // Check if error is due to reCAPTCHA failure
            console.log('----- error',error)
            if (error.data?.message === 'reCAPTCHA verification failed' && recaptchaRef.value) {
                failedCaptcha.value = error.data?.failed_cappcha || 0;
                if ( failedCaptcha.value < 3) {
                    // Get a new token
                    recaptchaRef.value.getToken();
                    setTimeout(async () => {
                        submitForm();
                    }, 1000);
                    return;
                }

            }
            responseMessage.value = error.message || error.data?.message || 'An error occurred. Please try again.';
        }finally {
            isSubmitting.value = false;
        }

    };

    // Block dates 14-18 only in February 2026
    const blockedDates = computed(() => {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();
        // Only block dates 14-18 in February 2026
        if (currentMonth === 1 && currentYear === 2026) {
            return [
                new Date(2026, 1, 14),
                new Date(2026, 1, 15),
                new Date(2026, 1, 16),
                new Date(2026, 1, 17),
                new Date(2026, 1, 18)
            ];
        }
        // No blocked dates in other months or years
        return [];
    });

    const validateForm = () => {
        let isValid = true;
        for (const key in errors.value) {
            errors.value[key] = null;
        }
        if (!form.value.store || form.value.store=='') {
            errors.value.store = 'Please select a store';
            isValid = false;
        }
        if (!form.value.first_name) {
            errors.value.first_name = 'Please enter your First name';
            isValid = false;
        } else if (!/^[A-Za-z ]+$/.test(form.value.first_name)) {
            errors.value.first_name = 'First Name cannot contain numbers';
            isValid = false;
        }

        if (!form.value.last_name) {
            errors.value.last_name = 'Please enter your Last name';
            isValid = false;
        } else if (!/^[A-Za-z ]+$/.test(form.value.last_name)) {
            errors.value.last_name = 'Last Name cannot contain numbers';
            isValid = false;
        }
        if (!form.value.phone) {
            errors.value.phone = 'Please enter your Contact number';
            isValid = false;
        } else if (!/^[0-9]+$/.test(form.value.phone)) {
            errors.value.phone = 'Contact Number cannot contain alphabets';
            isValid = false;
        } else if (form.value.phone.length < 9 || form.value.phone.length > 11) {
            errors.value.phone = 'Length is 9 - 11 characters.';
            isValid = false;
        }

        if (!form.value.email) {
            errors.value.email = 'Please enter your Email';
            isValid = false;
        } else if (!/^\S+@\S+\.\S+$/.test(form.value.email)) {
            errors.value.email = 'Please enter a valid email address';
            isValid = false;
        } else if (form.value.email.length > 50) {
            errors.value.email = 'Email cannot exceed 50 characters';
        }

        if (!form.value.date) {
            errors.value.date = 'Please select a date';
            isValid = false;
        }

        // if (form.value.agree_terms===false) {
        //     errors.value.agree_terms = 'This field is required';
        //     isValid = false;
        // }

        return isValid;
    };

    interface FormState {
        post_id : any;
        form_id: string;
        store: string;
        date: string;
        time: string;
        first_name: string;
        last_name: string;
        phone: string;
        email: string;
        message: string;
        item_marketing_consent: boolean;
        recaptcha: string;
    }

    // onMounted(() => {
    //     // siteKey.value = siteKey_recapcha;
    // });
    // onMounted(() => {
    //     // siteKey.value = siteKey_recapcha;
    //     setTimeout(() => {
    //         if (recaptchaRef.value){
    //             recaptchaRef.value.getToken();
    //         }
    //     }, 1000);
    // });

    const form = ref<FormState>({
        post_id : post_id_form,
        form_id: 'master_template',
        store: '',
        date: '',
        time: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        message: '',
        item_marketing_consent: false,
        recaptcha: ''
    });

    const errors = ref<{ [key: string]: string | null }>({
        store: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        period: null,
        item_marketing_consent: null,
    });

    const clearFieldError = (field: string) => {
        errors.value[field] = null;
    };

    const timeOptions = ref<{ value: string; label: string }[]>([
        { value: '11:00 AM', label: '11:00 AM' },
        { value: '11:30 AM', label: '11:30 AM' },
        { value: '12:00 PM', label: '12:00 PM' },
        { value: '12:30 PM', label: '12:30 PM' },
        { value: '1:00 PM', label: '1:00 PM' },
        { value: '1:30 PM', label: '1:30 PM' },
        { value: '2:00 PM', label: '2:00 PM' },
        { value: '2:30 PM', label: '2:30 PM' },
        { value: '3:00 PM', label: '3:00 PM' },
        { value: '3:30 PM', label: '3:30 PM' },
        { value: '4:00 PM', label: '4:00 PM' },
        { value: '4:30 PM', label: '4:30 PM' },
        { value: '5:00 PM', label: '5:00 PM' },
        { value: '5:30 PM', label: '5:30 PM' },
        { value: '6:00 PM', label: '6:00 PM' },
        { value: '6:30 PM', label: '6:30 PM' },
        { value: '7:00 PM', label: '7:00 PM' },
        { value: '7:30 PM', label: '7:30 PM' },
        { value: '8:00 PM', label: '8:00 PM' }

    ]);

    const formClicked = ref(false);
    watch(
        () => props.data_key,
        (newKey) => {
            if (newKey) {
                setTimeout(() => {
                    siteKey_recapcha.value = newKey; // Set siteKey after 1s delay
                }, 200); // 1-second delay

            }
        },
        { immediate: true }
    );
    const startLoadRecaptcha = () => {
        if (recaptchaRef.value){
            if(!formClicked.value){
                // loadRecaptchaScript(); // Call the function to load reCAPTCHA script
                recaptchaRef.value.loadRecaptchaScript();
                // Add a delay before attempting to retrieve the token
                setTimeout(async () => {
                    try {
                    const token = await recaptchaRef.value.getToken();
                    // Optionally store or use the token
                    } catch (error) {
                    console.error('Error fetching reCAPTCHA token:', error);
                    }
                }, 500);
            }
        }
        formClicked.value = true
    }

</script>
<style lang="scss" >
    @import "@/assets/scss/components/career/joblist";
    @import "@/assets/scss/components/career/kforms";
    @import '@/assets/scss/components/master-template/_form.scss';
    input.dp__input{
        padding-inline-start: 0;
    }
    .dp__menu.dp__menu_index{
        border-radius: 10px;
    }
    .dp__active_date{
        background-color: #AD073D !important;
        color: #fff !important;
        border: none;
    }
    .dp__calendar_header{
        font-weight: 400
    }
    .dp__calendar_row{
        margin-top: 0;
        margin-bottom: 0;
    }
    .dp__menu_inner{
        box-shadow: 0px 3px 10px 0 #D4CFD0;
        border-radius: 10px;
    }
    .dp__input_icon{
        right: 2px;
        left: auto;
        inset-inline-start: auto !important;
    }
    .dp--clear-btn {
        right: 20px !important;
    }

</style>